import { gql } from "@/__generated__";
import { generateDefaultSearchData } from "@/generators";
export var FIND_JOBS_QUERY = gql("\n  query FindJobs(\n    $what: String\n    $where: String\n    $filters: [FindJobsFilterInput!]\n    $jobFilters: JobFiltersInput\n    $remoteOnly: Boolean\n    $first: Int\n    $after: String\n    $isCareerSite: Boolean!\n    $jobKey: String\n    $currentUrl: WebUrl!\n    $includeDatePostedFilterOptions: Boolean!\n    $includeRemoteWorkTypeFilterOptions: Boolean!\n    $includeJobCategoryFilterOptions: Boolean!\n  ) {\n    findJobs(\n      input: {\n        what: $what,\n        where: $where,\n        filters: $filters,\n        jobFilters: $jobFilters,\n        remoteOnly: $remoteOnly,\n        jobKey: $jobKey,\n      }\n      first: $first\n      after: $after\n    ) {\n      edges {\n        node {\n          key\n          title\n          salary\n          type\n          location {\n            city\n            state\n            country\n          }\n          company\n          companyLogoUrl\n          postedDate\n          applyUrl(indeedApplyExitUrl: $currentUrl) @include(if: $isCareerSite)\n          clickTrackUrl @include(if: $isCareerSite)\n          clickUrl @skip(if: $isCareerSite)\n          impressionUrl @skip(if: $isCareerSite)\n          renderUrl @skip(if: $isCareerSite)\n          description {\n            html\n          }\n        }\n      }\n      pageInfo {\n        startCursor\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        nextPages {\n          pageNumber\n          cursor\n        }\n        previousPages {\n          pageNumber\n          cursor\n        }\n      }\n      filterOptions {\n        datePosted @include(if: $includeDatePostedFilterOptions) {\n          value\n          label\n        }\n        remoteWorkTypes @include(if: $includeRemoteWorkTypeFilterOptions) {\n          value\n          label\n        }\n        jobCategories @include(if: $includeJobCategoryFilterOptions) {\n          value\n          label\n        }\n      }\n    }\n  }\n");
// TODO handle null cursor in API
function getPagesFrom(multipages, currentPageNumber) {
    if (multipages == null) {
        return new Map();
    }
    var pages = new Map();
    multipages.previousPages.forEach(function (page) {
        pages.set(page.pageNumber + 1, page.cursor);
    });
    pages.set(currentPageNumber + 1, "");
    multipages.nextPages.forEach(function (page) {
        pages.set(page.pageNumber + 1, page.cursor);
    });
    return pages;
}
function getCurrentPageNumberFrom(previousPages) {
    return previousPages == null || previousPages.length === 0
        ? 0
        : Math.max.apply(Math, previousPages.map(function (page) {
            return page.pageNumber;
        })) + 1;
}
export function responseToSearchData(response) {
    var _a, _b, _c, _d, _e, _f;
    if (response == null || response.findJobs == null) {
        return generateDefaultSearchData();
    }
    var data = response.findJobs;
    var currentPageNumber = getCurrentPageNumberFrom(data.pageInfo.previousPages);
    var jobs = convertJobsToSearchData(response);
    return {
        pageCursors: getPagesFrom(data.pageInfo, currentPageNumber),
        jobs: jobs,
        filterOptions: {
            datePosted: (_b = (_a = data.filterOptions) === null || _a === void 0 ? void 0 : _a.datePosted) !== null && _b !== void 0 ? _b : [],
            remoteWorkTypes: (_d = (_c = data.filterOptions) === null || _c === void 0 ? void 0 : _c.remoteWorkTypes) !== null && _d !== void 0 ? _d : [],
            jobCategories: (_f = (_e = data.filterOptions) === null || _e === void 0 ? void 0 : _e.jobCategories) !== null && _f !== void 0 ? _f : [],
        },
    };
}
function convertJobsToSearchData(response) {
    var _a, _b;
    return ((_b = (_a = response.findJobs) === null || _a === void 0 ? void 0 : _a.edges.filter(function (edge) { return edge.node != null; }).flatMap(function (jobEdge) {
        return {
            datePublished: jobEdge.node.postedDate,
            company: jobEdge.node.company || "",
            companyLogo: jobEdge.node.companyLogoUrl || undefined,
            location: jobEdge.node.location.city,
            jobKey: jobEdge.node.key,
            title: jobEdge.node.title,
            url: jobEdge.node.applyUrl || jobEdge.node.clickUrl,
            clickTrackUrl: jobEdge.node.clickTrackUrl || undefined,
            impressionViewUrl: jobEdge.node.impressionUrl || undefined,
            impressionRenderUrl: jobEdge.node.renderUrl || undefined,
            description: jobEdge.node.description.html,
            type: jobEdge.node.type || undefined,
            salary: jobEdge.node.salary || undefined,
        };
    })) !== null && _b !== void 0 ? _b : []);
}
